<template>
  <div class="employee-insurance-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'EmployeeInsurance',
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.employee-insurance-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>